import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoaderCstm from "../../../components/Loader";
import { signUpWithEmail } from "../../../lib/store/actions";
import styles from "../../../components/Layout/Authlayout/Authe.module.scss";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const Signup = () => {
  // const { t } = useTranslation();
  const t = useLanguage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector(({ Auth }) => Auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const onClickSignup = () => {
    setError(null);

    if (!email || !password || !confirmPassword) {
      setError("Please fill all fields.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    // setLoader(true);
    dispatch(
      signUpWithEmail({
        data: { email, password, confirmPassword },
        callBack: (err, res) => {
          // console.info("Sign up Res =======>", res);
          if (parseInt(err?.status_code) === 406) {
            setLoader(false);
            return navigate("/maintenance");
          }
          if (err) {
            setError(err.message || "Failed to sign up.");
            return;
          } else {
            // console.info("navigate to verify popup ===> ")
            navigate("/verify-otp", { state: { email } });
            return;
          }
        },
      })
    );
  };

  return (
    <>
      {loader || loading ? (
        <div className="d-flex justify-content-center my-3">
          <LoaderCstm />
        </div>
      ) : (
        <div className="formBody">
          <Form>
            <div className="py-2">
              <label
                htmlFor="email"
                className="form-label m-0 text-white w-100 text-start"
              >
                {t("signup.enter_email")}
              </label>
              <input
                id="email"
                type="email"
                placeholder={t("signup.enter_email")}
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="py-2">
              <label
                htmlFor="password"
                className="form-label m-0 text-white w-100 text-start"
              >
                {t("signup.pasword")}
              </label>
              <div className="iconWithText position-relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="*******"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
                <button
                  className="position-absolute icn border-0 p-0 bg-transparent"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: 10,
                  }}
                >
                  <i
                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                  ></i>
                </button>
              </div>
            </div>

            <div className="py-2">
              <label
                htmlFor="confirmPassword"
                className="form-label m-0 text-white w-100 text-start"
              >
                {t("signup.confirm_password")}
              </label>
              <div className="iconWithText position-relative">
                <input
                  id="confirmPassword"
                  type={showCPassword ? "text" : "password"}
                  placeholder="*******"
                  className="form-control"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={loading}
                />
                <button
                  className="position-absolute icn border-0 p-0 bg-transparent"
                  type="button"
                  onClick={() => setShowCPassword(!showCPassword)}
                  disabled={loading}
                  style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: 10,
                  }}
                >
                  <i
                    className={`fa ${
                      showCPassword ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                </button>
              </div>
            </div>

            {error && <div className="text-danger py-2">{error}</div>}

            <div className="py-2">
              <Button
                style={{ maxWidth: 250 }}
                className={`${styles.telegramBtn} mx-auto rounded-pill w-100 d-flex px-4 align-items-center justify-content-center mt-2`}
                onClick={onClickSignup}
                disabled={loading}
              >
                {t("signup.sign_up")}
              </Button>
            </div>
          </Form>

          <div>
            <p className="m-0 py-2 text-white mt-2">
              {t("signup.already_have_account")}{" "}
              <Link to={"/sign-in"} className="themeClr fw-sbold">
                {t("signup.sign_in_with_email")}
              </Link>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Signup;
